<article class="don-card">
    <div class="don-card__content">
        <div class="don-text">
            <div class="don-title">
                {{ vm.title }}
            </div>

            <div class="don-address-row">
                <span *ngIf="vm.address" class="meta-address" [cxTip]="vm.address">
                    {{ vm.address }}
                </span>

                <span *ngIf="!vm.address" class="meta-address meta-address--empty">
                    —
                </span>
            </div>

            <div class="don-date-row">
                <span class="meta-date" [attr.title]="vm.dateISO | date:'fullDate'">
                    {{ vm.dateISO | date:'MMM d, y' }}
                </span>

                <span class="meta-dot">·</span>

                <span class="meta-time-ago" [attr.title]="vm.dateISO | date:'medium'">
                    {{ vm.dateISO | timeAgo }}
                </span>
            </div>
        </div>

        <div class="don-amount-ticket" [ngClass]="vm.donationType === 'recurring' ? 'is-recurring' : 'is-one-time'"
            [attr.aria-label]="'Amount ' + vm.amountLabel + ' ' + (vm.donationType === 'recurring' ? 'per month' : 'one-time')">
            <div class="amount">{{ vm.amountLabel }}</div>
            <div class="sub">
                {{ vm.donationType === 'recurring' ? ('CAMPAIGN.DonationType.Monthly' | translate) : ('CAMPAIGN.DonationType.OneTime' | translate) }}
            </div>
        </div>

        <!-- 
      <button
        class="don-like-inline"
        type="button"
        (click)="like.emit(vm.id)"
        [attr.aria-label]="'Love ' + vm.title">
        <img
          class="like-icon"
          [src]="vm.likes ? 'assets/Image/icons-donate/_like-true.svg' : 'assets/Image/icons-donate/_like-false.svg'"
          alt="">
        <span class="like-count">{{ vm.likes }}</span>
      </button>
      -->
    </div>
</article>